// TransferPitch corner mark for the chat profile-preview cards.
//
// Earlier this rendered an inline SVG "tp" wordmark because the PNG
// asset only existed on a feature branch that wasn't merged yet. The
// transfer-windows-redesign branch (which shipped the real tp-icon.png)
// is now in marin-local, so we use the actual brand asset and drop
// the hand-rolled placeholder.
//
// The halo + drop-shadow container stay so the card header still has
// the same visual weight as the previous SVG version.

import React from "react";

import tpIcon from "../../assets/images/tp-icon.png";

export function TpMark({ size = 26 }) {
  const r = Math.max(2, Math.round(size * 0.18));
  return (
    <span
      aria-label="TransferPitch"
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        flexShrink: 0,
      }}
    >
      {/* Soft halo behind the icon — kept from the previous SVG
          version so the chat header still pops on grey bubbles. */}
      <span
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: -Math.round(size * 0.45),
          background:
            "radial-gradient(circle, rgba(74,144,217,0.45) 0%, rgba(74,144,217,0.15) 40%, rgba(74,144,217,0) 75%)",
          filter: "blur(2px)",
          pointerEvents: "none",
        }}
      />
      <img
        src={tpIcon}
        alt=""
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          borderRadius: r,
          position: "relative",
          zIndex: 1,
          display: "block",
        }}
      />
    </span>
  );
}
